export const getBaseUrl = (defaultValue?: string): string | undefined => {
  return window.env?.REACT_APP_API_URL ?? import.meta.env.REACT_APP_API_URL ?? defaultValue;
};

export const getAuth0LogoutRedirect = (defaultValue?: string): string | undefined => {
  return window.env?.REACT_APP_AUTH0_LOGOUT_REDIRECT ?? import.meta.env.REACT_APP_AUTH0_LOGOUT_REDIRECT ?? defaultValue;
};

export const getAuth0Domain = (defaultValue?: string): string => {
  return window.env?.REACT_APP_AUTH0_DOMAIN ?? import.meta.env.REACT_APP_AUTH0_DOMAIN ?? defaultValue ?? '';
};

export const getAuth0ClientId = (defaultValue?: string): string => {
  return window.env?.REACT_APP_AUTH0_CLIENT_ID ?? import.meta.env.REACT_APP_AUTH0_CLIENT_ID ?? defaultValue ?? '';
};

export const getAuth0Audience = (defaultValue?: string): string => {
  return window.env?.REACT_APP_AUTH0_AUDIENCE ?? import.meta.env.REACT_APP_AUTH0_AUDIENCE ?? defaultValue ?? '';
};

export const getAgGridLicenseKey = (defaultValue?: string): string | undefined => {
  return window.env?.REACT_APP_AG_GRID_LICENSE_KEY ?? import.meta.env.REACT_APP_AG_GRID_LICENSE_KEY ?? defaultValue;
};

export const getSentryDsn = (defaultValue?: string): string | undefined => {
  return window.env?.REACT_APP_SENTRY_DSN ?? import.meta.env.REACT_APP_SENTRY_DSN ?? defaultValue;
};

export const getSentryProject = (defaultValue?: string): string | undefined => {
  return window.env?.REACT_APP_SENTRY_PROJECT ?? import.meta.env.REACT_APP_SENTRY_PROJECT ?? defaultValue;
};

export const getSentryEnv = (defaultValue?: string): string | undefined => {
  return window.env?.REACT_APP_SENTRY_ENV ?? import.meta.env.REACT_APP_SENTRY_ENV ?? defaultValue;
};

export const getSentryErrorSampleRate = (defaultValue?: string): string => {
  return (
    window.env?.REACT_APP_SENTRY_ERROR_SAMPLE_RATE ??
    import.meta.env.REACT_APP_SENTRY_ERROR_SAMPLE_RATE ??
    defaultValue ??
    ''
  );
};

export const getSentryTracingSampleRate = (defaultValue?: string): string => {
  return (
    window.env?.REACT_APP_SENTRY_TRACING_SAMPLE_RATE ??
    import.meta.env.REACT_APP_SENTRY_TRACING_SAMPLE_RATE ??
    defaultValue ??
    ''
  );
};

export const getSentryProfilingRate = (defaultValue?: string): string => {
  return (
    window.env?.REACT_APP_SENTRY_PROFILING_RATE ?? import.meta.env.REACT_APP_SENTRY_PROFILING_RATE ?? defaultValue ?? ''
  );
};

export const getSentryErrorReplaysSampleRate = (defaultValue?: string): string => {
  return (
    window.env?.REACT_APP_SENTRY_ERROR_REPLAYS_SAMPLE_RATE ??
    import.meta.env.REACT_APP_SENTRY_ERROR_REPLAYS_SAMPLE_RATE ??
    defaultValue ??
    ''
  );
};

export const getLocizeProjectId = (defaultValue?: string): string => {
  return window.env?.REACT_APP_LOCIZE_PROJECT_ID ?? import.meta.env.REACT_APP_LOCIZE_PROJECT_ID ?? defaultValue ?? '';
};

export const getLocizeApiKey = (defaultValue?: string): string => {
  return window.env?.REACT_APP_LOCIZE_API_KEY ?? import.meta.env.REACT_APP_LOCIZE_API_KEY ?? defaultValue ?? '';
};

export const getInspectletWid = (defaultValue?: string): string | undefined => {
  return window.env?.REACT_APP_INSPECTLET_WID ?? import.meta.env.REACT_APP_INSPECTLET_WID ?? defaultValue;
};

export const getIntercomAppId = (defaultValue?: string): string => {
  return window.env?.REACT_APP_INTERCOM_APP_ID ?? import.meta.env.REACT_APP_INTERCOM_APP_ID ?? defaultValue ?? '';
};

export const getGoogleMapApiKey = (defaultValue?: string): string => {
  return window.env?.REACT_APP_GOOGLE_MAP_API_KEY ?? import.meta.env.REACT_APP_GOOGLE_MAP_API_KEY ?? defaultValue ?? '';
};

export const getGoogleMapId = (defaultValue?: string): string => {
  return window.env?.REACT_APP_GOOGLE_MAP_ID ?? import.meta.env.REACT_APP_GOOGLE_MAP_ID ?? defaultValue ?? '';
};

export const getHotjarHjid = (defaultValue?: string): string | undefined => {
  return window.env?.REACT_APP_HOTJAR_HJID ?? import.meta.env.REACT_APP_HOTJAR_HJID ?? defaultValue;
};

export const getHotjarHjsv = (defaultValue?: string): string | undefined => {
  return window.env?.REACT_APP_HOTJAR_HJSV ?? import.meta.env.REACT_APP_HOTJAR_HJSV ?? defaultValue;
};

export const getLdClientSideId = (defaultValue?: string): string | undefined => {
  return window.env?.REACT_APP_LD_CLIENT_SIDE_ID ?? import.meta.env.REACT_APP_LD_CLIENT_SIDE_ID ?? defaultValue;
};

export const getBuildVersion = (defaultValue?: string): string | undefined => {
  return window.env?.REACT_APP_BUILD_VERSION ?? import.meta.env.REACT_APP_BUILD_VERSION ?? defaultValue;
};

export const getMutateDelay = (defaultValue: string): number => {
  const delay = window.env?.REACT_APP_DELAY_MUTATE ?? import.meta.env.REACT_APP_DELAY_MUTATE ?? defaultValue;
  return parseInt(delay);
};
